<template>
	<div class="d-flex">
		<div class="dropdown position-static mr-2" v-if="isShowActions">
			<button data-toggle="dropdown" data-boundary="viewport" role="button" class="btn btn-default btn-sm d-none d-sm-inline-block" aria-expanded="false" data-offset="0,5px">
				<svg class="icon-svg fs-15"><use :href="spritePath + '#menu'"></use></svg>
				<span>{{ localize.actions }}</span>
			</button>
			<button data-toggle="dropdown" data-boundary="viewport" role="button" class="btn btn-default btn-icon btn-sm d-sm-none" aria-expanded="false" data-offset="0,5px">
				<svg class="icon-svg fs-15"><use :href="spritePath + '#menu'"></use></svg>
			</button>
			<div class="dropdown-menu dropdown-menu-right rounded-lg" ref="actions">
				<ul class="kt-nav kt-nav--fit-ver">

					<li v-if="options.previewSwitcher" class="kt-nav__section kt-margin-t-10">
						<span class="kt-nav__section-text">{{ localize.settings }}</span>
					</li>

					<li v-if="options.previewSwitcher" class="kt-nav__section mt-0">
						<div class="form-group row mb-0">
							<label class="col-auto col-form-label">{{ localize.switcher }}</label>
							<div class="col">
								<span class="kt-switch kt-switch--sm kt-switch--primary">
									<label>
										<input type="checkbox" :checked="previewSwitcher" @change="togglePreviewSwitcher">
										<span></span>
									</label>
								</span>
							</div>
						</div>
					</li>

					<li class="kt-nav__section mb-1" v-if="exports.length > 0">
						<span class="kt-nav__section-text">{{ localize.export }}</span>
					</li>

					<li class="kt-nav__item" v-for="({name, url}, index) in exports" :key="index">
						<a :href="url" target="_blank" class="kt-nav__link">
							<svg class="kt-nav__link-icon icon-svg text-primary"><use :href="spritePath + '#file-solid'"></use></svg>
							<span class="kt-nav__link-text text-primary text-uppercase">{{ name }}</span>
						</a>
					</li>

				</ul>
			</div>
		</div>
		<button
			class="btn btn-primary btn-sm text-nowrap"
			:class="{disabled: !canBuySelectedRows.length }"
			@click="addtobasket"
		>
			{{ labelAddtobasket }}
		</button>
	</div>
</template>

<script>

const EXPORT_TYPES = ['csv', 'ods', 'xlsx'];

export default {

	data()
	{
		return {
			selectedRows: [],
			page: window.location.pathname
		};
	},

	mounted()
	{
		this.eventBus.$on('onSelectedRowsChanged', selectedRows => this.selectedRows = selectedRows);

		this.eventBus.$on('afterRequest', () => {
			this.page = window.location.pathname + window.location.search;
		});

		$(this.$refs.actions).on('click', event => {
			event.stopPropagation();
		});
	},

	computed: {

		options()
		{
			return this.$store.getters[`${this.$root.$namespace}/getToolbarOptions`];
		},

		eventBus()
		{
			return this.$root.$eventBus || this;
		},

		canBuySelectedRows()
		{
			return this.selectedRows.filter(row => (row.products[row.selected] || {}).canBuy);
		},

		localize()
		{
			return Object.freeze({
				'addtobasket': BX.message('RS.B2BPORTAL.ADD_TO_BASKET_LABEL'),
				'actions': BX.message('RS.B2BPORTAL.ACTIONS_LABEL'),
				'settings': BX.message('RS.B2BPORTAL.SETTINGS_LABEL'),
				'switcher': BX.message('RS.B2BPORTAL.IMAGE_SWITCHER_LABEL'),
				'export': BX.message('RS.B2BPORTAL.EXPORT_LABEL')
			})
		},

		labelAddtobasket()
		{
			return this.localize.addtobasket.replace('#COUNT#', this.canBuySelectedRows.length)
		},

		previewSwitcher()
		{
			return this.$store.getters[`${this.$root.$namespace}/isShowPreview`];
		},

		exports()
		{
			if (!this.options.export)
				return [];

			return this.options.exportTypes.filter(type => EXPORT_TYPES.includes(type)).map(type => {
				const uri = new BX.Uri((this.page || ''));
				uri.setQueryParam('export', type);

				return {
					name: type,
					url: uri.toString()
				};
			});
		},

		isShowActions()
		{
			return this.options.previewSwitcher || this.exports.length > 0;
		},

		spritePath()
		{
			return B2BPortal.config.spritePath;
		},
	},

	methods: {

		addtobasket()
		{
			if (!this.selectedRows.length)
				return;

			this.$emit('addtobasket', this.selectedRows);
		},

		togglePreviewSwitcher()
		{
			this.$store.dispatch(`${this.$root.$namespace}/togglePreview`);
		}
	},
}
</script>